/**
 * Page changes (snippets/page-loader.liquid): switches the page-change icon on and off.
 * When and why: assets/base.css.
 */
(() => {
  const loader = document.querySelector('[data-page-loader]');
  if (!loader) return;
  const checkout = /\/(checkouts?|cart\/c)([/?]|$)/;
  let taps = 0;
  let undo = 0;

  const show = (on) => {
    clearTimeout(undo);
    loader.classList.toggle('is-shown', on);
    if (loader.togglePopover) loader.togglePopover(on);
  };
  const stop = () => show(false);
  const leaves = (event) => {
    const a = event.target.closest('a[href]');
    return a && !(event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) && a.origin === location.origin &&
      !(a.target && a.target !== '_self') && !a.hasAttribute('download') && !checkout.test(a.pathname) &&
      a.pathname + a.search !== location.pathname + location.search;
  };

  addEventListener('pointerdown', stop);
  addEventListener('pointercancel', stop);
  addEventListener(loader.dataset.wait < 300 ? 'pointerup' : 'pointerdown', (event) => {
    if (!leaves(event)) return;
    show(true);
    undo = setTimeout(stop, 250);
  });
  addEventListener('click', (event) => {
    if (event.defaultPrevented || !leaves(event)) return stop();
    taps += 1;
    show(true);
  });
  addEventListener('pagehide', stop);
  addEventListener('pageshow', (event) => event.persisted && stop());
  addEventListener('keydown', (event) => event.key === 'Escape' && stop());
  loader.addEventListener('animationend', (event) => event.target === loader && stop());
  // A stopped load takes it away.
  if (window.navigation) {
    navigation.addEventListener('navigate', (event) => {
      const mine = taps;
      event.signal.addEventListener('abort', () => mine === taps && stop());
    });
  }
  // No fade to the checkout: it asks for none, and Chrome reports an error there.
  addEventListener('pageswap', (event) => event.viewTransition && checkout.test(event.activation?.entry.url) && event.viewTransition.skipTransition());
})();
